import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';

type EmptyListProps = {
  /** Function to call when add bulletin button is pressed */
  onAdd: () => void;
  /**
   * Flag to indicate if bulletins are updating, Add content will be disabled
   * while true
   */
  isUpdating: boolean;
};

export function EmptyList({ onAdd, isUpdating }: EmptyListProps): JSX.Element {
  return (
    <FlexBox
      flexDirection="column"
      alignItems="center"
      padding="60px 0"
      borderRadius="4px"
      borderColor="neutral.200"
    >
      <Text.Heading variant="heading-3">Nothing added yet</Text.Heading>
      <Text.Paragraph variant="4" withMarginBottom>
        Get started by adding your first bit of content below.
      </Text.Paragraph>
      <Button disabled={isUpdating} onClick={onAdd} variant="secondary">
        Add content
      </Button>
    </FlexBox>
  );
}
